import { render, staticRenderFns } from "./bo-textarea-word-count.vue?vue&type=template&id=5452391d"
import script from "./bo-textarea-word-count.vue?vue&type=script&lang=js"
export * from "./bo-textarea-word-count.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports